import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import Steps1 from '../../scss/images/icon-steps-1.svg';
import Steps2 from '../../scss/images/icon-steps-2.svg';
import Steps3 from '../../scss/images/icon-steps-3.svg';
import Steps4 from '../../scss/images/icon-steps-4.svg';

const Steps: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="upgrade-steps">
      <div className="upgrade-steps-wrap">
        <div className="upgrade-steps-item">
          <div className="icon">
            <LazyLoadImage src={Steps1} />
          </div>
          <span className="text">
            {t(
              'Select one of your skins on the left to upgrade and get a more expensive one',
            )}
          </span>
        </div>
        <div className="upgrade-steps-item">
          <div className="icon">
            <LazyLoadImage src={Steps2} />
          </div>
          <span className="text">
            {t(
              'You can also use your account balance as input instead of a skin',
            )}
          </span>
        </div>
        <div className="upgrade-steps-item">
          <div className="icon">
            <LazyLoadImage src={Steps3} />
          </div>
          <span className="text">
            {t('Select the skin on the right to which you want to upgrade')}
          </span>
        </div>
        <div className="upgrade-steps-item">
          <div className="icon">
            <LazyLoadImage src={Steps4} />
          </div>
          <span className="text">{t('upgrade-steps-item 4')}</span>
        </div>
      </div>
    </div>
  );
};

export default Steps;
